<template lang="pug">
.generic-wrapper
  .container
    h1.title Finanzen
    .sub-headline Hier können Sie alle Rechnungs-relevanten Aktionen steuern.

    MenuItems
      MenuItem(name="Rechnungen" description="Hier können Sie alle erstellte Rechnungen einsehen." @click="$router.push({name: 'FinancesInvoices'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            line(x1='12' y1='1' x2='12' y2='23')
            path(d='M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6')
      MenuItem(name="Rechnungserstellung" description="Hier können Sie eine neue Rechnung erstellen." @click="$router.push({name: 'CreateFinancesInvoices'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            line(x1='12' y1='1' x2='12' y2='23')
            path(d='M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6')
      MenuItem(name="Eigentümerabrechnung" description="Hier können Sie eine neue Eigentümerabrechnung erstellen." @click="$router.push({name: 'FinancesOwnerSettlements'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            line(x1='12' y1='1' x2='12' y2='23')
            path(d='M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6')
</template>

<script>
import MenuItem from "@/components/atoms/MenuItem.vue";
import MenuItems from "@/components/molecules/MenuItems.vue";

export default {
  components: {
    MenuItem,
    MenuItems
  }
};
</script>